import { Routes, Route } from 'react-router-dom';
import { ComponentExplorerPage } from './pages/ComponentExplorerPage';
import { AuthGuard } from './components/AuthGuard';
import { IntegratedComponentProvider } from '@components/integrated/shared';
import { ceApiClient } from './api/ceApiClient';
import { useCEAuthStore } from './auth/store';

export function ComponentExplorerRoutes() {
  const activeTenantId = useCEAuthStore((s) => s.activeTenantId);

  return (
    <AuthGuard>
      <IntegratedComponentProvider apiClient={ceApiClient} tenant={activeTenantId ?? ''} module="component-explorer">
        <Routes>
          <Route path="/" element={<ComponentExplorerPage />} />
          <Route path="/:componentId" element={<ComponentExplorerPage />} />
        </Routes>
      </IntegratedComponentProvider>
    </AuthGuard>
  );
}
